import moment, { Moment } from "moment";
import { isNumeric } from "rxjs/internal-compatibility";

import { BaseCmsContentModel } from "../../../models/base-cms-content.model";
import { CmsContentAttributeModel } from "../../../models/cms-content-attribute.model";
import { CmsContentPropertyModel } from "../../../models/cms-content-property.model";

export class DirectoryItemModel extends BaseCmsContentModel {
    public static DEFAULT_IMAGE_URL = "https://www.connecttosupport.org/bm/App_Themes/Default/Images/Default-Catalogue.png";

    public id: string;

    public latitude: number;
    public longitude: number;
    public occurrences: Array<string>;
    public occurrenceDate: Moment;
    public startTime: string;
    public endTime: string;

    public attributes: Array<CmsContentAttributeModel> = [];
    public properties: Array<CmsContentPropertyModel> = [];

    public constructor(model: any) {
        super();

        this.id = model.id;

        this.name = model.name;
        this.description = model.description;
        this.url = model.url;

        this.latitude = model.latitude;
        this.longitude = model.longitude;
        this.occurrences = model.occurrences;
        this.occurrenceDate = model.occurrenceDate ? moment(model.occurrenceDate) : null;

        this.attributes = model.attributes;
        this.properties = model.properties;
    }

    public get imageUrl(): string { return this.getPropertyValue<string>("DetailsImageUrl"); }
    public get address(): string { return this.getPropertyValue<string>("Address"); }
    public get postcode(): string { return this.getPropertyValue<string>("Postcode"); }
    public get phone(): string { return this.getPropertyValue<string>("Phone"); }
    public get email(): string { return this.getPropertyValue<string>("Email"); }
    public get website(): string { return this.getPropertyValue<string>("Website"); }

    public get hasImage(): boolean {
        return this.imageUrl && (this.imageUrl !== DirectoryItemModel.DEFAULT_IMAGE_URL);
    }

    public get hasValidAddress(): boolean {
        return this.address && (this.address !== ".");
    }

    public get hasValidPostcode(): boolean {
        return !!this.postcode;
    }

    public get hasValidPhoneNumber(): boolean {
        return !!this.phone;
    }

    public get hasValidEmailAddress(): boolean {
        return this.email && (this.email.indexOf("@") > 0) && (this.email.toLowerCase() !== "no@email.com");
    }

    public get hasValidWebsiteAddress(): boolean {
        return this.website && (this.website !== "#") && (this.website.toLowerCase() !== "null") && (this.website.toLowerCase() !== "no");
    }

    public get hasValidGeoLocation(): boolean {
        return this.latitude && isNumeric(this.latitude) && this.longitude && isNumeric(this.longitude);
    }

    protected hasProperty(alias: string): boolean {
        return this.properties.some(property => property.alias === alias);
    }

    protected getPropertyValue<T>(alias: string): T {
        return this.hasProperty(alias) ? this.properties.find(property => property.alias === alias).value as T : null;
    }
}
